export default "__VITE_ASSET__CBtnplgn__"